<script setup lang="ts">
const toast = useToast()
const email = ref('')
const loading = ref(false)
const isSubscribed = ref(false)

async function onSubmit() {
  if (!email.value) return

  loading.value = true
  try {
    const response = await fetch('https://buttondown.com/api/emails/create-subscriber', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email_address: email.value,
        newsletter_id: '4371a3f6-0020-445d-8355-589f39452756'
      })
    })

    const data = await response.json()

    if (response.ok) {
      isSubscribed.value = true
      toast.add({
        title: 'Subscribed!',
        description: 'Please check your inbox for a confirmation email!',
        color: 'success'
      })
    } else {
      toast.add({
        title: 'Subscription failed',
        description: data.detail || data.error || 'Something went wrong. Please try again.',
        color: 'error'
      })
    }
  } catch (error) {
    console.error(error)
    toast.add({
      title: 'Error',
      description: 'Failed to subscribe. Please try again later.',
      color: 'error'
    })
  } finally {
    if (!isSubscribed.value) {
      loading.value = false
    }
  }
}
</script>

<template>
  <form @submit.prevent="onSubmit">
    <UFormField
      name="email"
      label="Subscribe to our newsletter"
      size="lg"
    >
      <UInput
        v-model="email"
        type="email"
        class="w-full"
        placeholder="Enter your email"
        :disabled="loading || isSubscribed"
      >
        <template #trailing>
          <UButton
            type="submit"
            size="xs"
            color="neutral"
            label="Subscribe"
            :loading="loading && !isSubscribed"
            :disabled="loading || isSubscribed"
          />
        </template>
      </UInput>
    </UFormField>
  </form>
</template>
